import { RouteComponentProps, navigate } from "@reach/router";
import { gql } from "graphql-tag";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import logger from "services/logger";
import { newOrg } from "types/gql-types";
import styles from "../adminDashboard.module.css";
import OrganizationForm, { OrgForm } from "./form";

const CREATE_ORG = gql`
  mutation newOrg($data: OrganizationInput!) {
    createOrganization(data: $data) {
      id
      name
    }
  }
`;

// defaulting type to property per discussion with adam
const initialData = {
  name: "",
  type: "property",
  email: "",
  bccEmail: "",
  phone: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
};


const NewOrganization: React.FC<RouteComponentProps> = () => {
  const [sending, setSending] = useState(false);
  const [createOrgFunc] = useMutation<newOrg>(CREATE_ORG);
  const submitForm = (formData: OrgForm) => {
    setSending(true);
    createOrgFunc({ variables: { data: formData } })
      .then(() => navigate("/dash/admin/organizations"))
      .catch((err) => {
        logger.sendError(err);
        setSending(false);
      });
  };
  return (
    <div>
      <h3 className={`${styles.headin}`}>Create an Organization</h3>
      <OrganizationForm
        formType="new"
        initialData={initialData}
        sending={sending}
        handleSubmit={submitForm}
      />
    </div>);

};

export default NewOrganization;
